var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import './index.scss';
import ribbonDev from '../../images/ribbon_dev.png';
import ribbonStg from '../../images/ribbon_stg.png';
var EnvironmentRibbon = function () {
    var environmentRibbon = function () {
        switch (process.env.REACT_APP_ENV) {
            case 'dev':
            case 'local':
                return _jsx("img", { alt: 'dev environment', className: 'env-ribbon', src: ribbonDev });
            case 'stg':
                return _jsx("img", { alt: 'test environment', className: 'env-ribbon', src: ribbonStg });
            default:
        }
    };
    return (_jsx("div", __assign({ className: 'environment-ribbon' }, { children: _jsx(Link, __assign({ to: '/' }, { children: environmentRibbon() })) })));
};
export default EnvironmentRibbon;
